

























import '@toast-ui/editor/dist/toastui-editor.css';

import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { Editor as TuiEditor } from '@toast-ui/vue-editor';

import { defineEditorOptions } from './lib';

@Component({
    components: {
        TuiEditor,
    }
})
export default class BaseEditor extends Vue {
    // not adding v-model support since there's no 2-way binding:
    // editor content won't be sync'ed when prop is updated
    @Prop({ default: '' }) readonly initialContent!: string
    @Prop({ default: '' }) readonly placeholder!: string;

    @Ref() tuiEditor!: TuiEditor;

    content = '';
    isHTML = false;
    isSaved = true;

    get editorOptions() {
        return defineEditorOptions({
            placeholder: this.placeholder,
        });
    }
    
    getContent() {
        return this.tuiEditor.invoke('getHTML');
    }

    async toggleIsHTML() {
        this.isHTML = !this.isHTML;
    }

    updateContent() {
        this.content = this.getContent();
        this.$emit('update:content', this.content);
    }

    updateContentFromHTML(event: InputEvent) {
        this.content = (event?.target as HTMLFormElement).value || this.content;
        this.$emit('update:content', this.content);
    }

    clickOutsideEvent(event: Event){
        const el = event.target as HTMLInputElement;
        if (!(this.$el == event.target || this.$el.contains(el)) && !this.isSaved) {
            this.isSaved = true;            
            this.updateContent();
        }
    }

    bindClickOutside(){
        document.body.addEventListener('click', this.clickOutsideEvent)
    }
    unbindClickOutside(){
        document.body.removeEventListener('click', this.clickOutsideEvent)
    }
    
    mounted() {
        this.bindClickOutside();
        this.content = this.getContent();
    }
    beforeDestroy(){
        this.unbindClickOutside();
    }


    @Watch('initialContent')
    onPropertyChanged(value: string, oldValue: string) {
        // after initialContent loaded
        if(!oldValue && value){
            this.content = this.content ? this.content : this.initialContent;
            this.tuiEditor.invoke('setHTML', this.content)
        }
    }
    
}
